import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';

export default class MonsterBadge extends WritingBadge {
  public readonly id = BadgeId.monster;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.streakInfo.current >= 20 || stats.streakInfo.longest >= 20;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/monster.ts